'use client';

import { Suspense } from 'react';
import Footer from './Footer';
import { useUrlParams } from '@/hooks/useUrlParams';

function FooterWithParams() {
  const { initialOpenSection } = useUrlParams();
  
  return <Footer initialOpenSection={initialOpenSection} />;
}

export default function FooterWrapper() {
  return (
    <Suspense fallback={<Footer />}>
      <FooterWithParams />
    </Suspense>
  );
}
